// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import ModalWrapper from '../../../../../components/ModalWrapper';
import DifferentiationDetailModal from './DifferentiationDetailModal';
import type { UniquenessType } from '../../../../../types/apolloType';
import { roundValue } from '../../../../../utils/formatUtils';

type Props = {
  uniqueness: UniquenessType,
};

type State = {
  showDetails: boolean,
};

class DifferentiationComponent extends React.Component<Props, State> {
  state = {
    showDetails: false,
  }

  showDetails = (show: boolean) => {
    this.setState({ showDetails: show });
  }

  render() {
    return (
      <div className="differentiation">
        <div className="uniqueness-score-container">
          <div className="uniqueness-score">
            <Translate value="attractiveScore.differentiation.product" />
            <div className="score">
              <Translate
                value="attractiveScore.score"
                score={roundValue(this.props.uniqueness.productsUniqueness.note)}
              />
            </div>
          </div>
          <div className="uniqueness-score">
            <Translate value="attractiveScore.differentiation.store" />
            <div className="score">
              <Translate
                value="attractiveScore.score"
                score={roundValue(this.props.uniqueness.storesUniqueness.note)}
              />
            </div>
          </div>
        </div>
        <button
          className="apollo-button-contained"
          onClick={() => this.showDetails(true)}
        >
          <Translate value="attractiveScore.differentiation.details.button" />
        </button>
        {
          this.state.showDetails
          && (
            <ModalWrapper
              title={<Translate value="attractiveScore.differentiation.details.title" />}
              showModal={this.showDetails}
              content={(<DifferentiationDetailModal uniqueness={this.props.uniqueness} />)}
              className="differentiation_details-modal"
            />
          )
        }
      </div>
    );
  }
}

export default DifferentiationComponent;
